
import React from 'react';
import styles from './Styles.module.scss';

class TermsView extends React.Component {

    render() {
      return (
      <div className={styles.content}>
        <h2><u>TERMS OF USE</u></h2>
        <p><strong>Last Updated 22nd August 2022</strong></p>
        <p>
          Please read the following terms and conditions carefully before using
          this site. By using the services provided by Paperflite Inc
          (hereinafter &quot;<strong>Paperflite</strong>&quot;, &quot;<strong>us</strong>&quot;,
            &quot;<strong>we</strong>&quot;, &quot;<strong>company</strong>&quot;) you agree to be bound by the Terms
          and Conditions of Use (&quot;<strong>Terms</strong>&quot;) and our
          Privacy Policy (together the &quot;<strong>Agreements</strong>&quot;).
          If you don&rsquo;t agree with these Terms, then please desist use of
          this Service.
        </p>

        <p>Occasionally we may, in our discretion, make changes to the
          Paperflite Service and Agreements. When we make changes to the
          Agreements that we consider material, we&rsquo;ll notify you through
          the Service. By continuing to use the Service after those changes are
          made, you are expressing and acknowledging your acceptance of the
          changes.</p>

        <h4><strong>1. <u>DEFINITIONS</u></strong></h4>

        <ol type="a">
          <li>&quot;<strong>You</strong>&quot; or &quot;<strong>User</strong>&quot;
            shall mean any natural or legal person who has agreed to become a
            user of by signing up to the Website/App. The Website/App also
            provides certain services without registration/acceptance, and such
            provision of services does not absolve you of this contractual
            relationship. &nbsp;&quot;<strong>User</strong>&quot; also includes
            Customer&rsquo;s employees or contractors or agents or any other
            individuals that Customer has nominated to subscribe to the Site,
            App, and Service or by Paperflite on behalf and on request by the
            customer
          </li>
          <li>&quot;<strong>Customer</strong>&quot; shall mean any User
            who shall utilize the Website/App to request for or obtain Services
            to be performed by Paperflite and or any Service Provider with or
            without registration.
          </li>
          <li>&quot;<strong>Third Party</strong>&quot; shall mean and
            refer to any individual(s), enterprise or entity apart from the
            Users, Customers, and Paperflite.
          </li>
          <li>The terms &quot;<strong>Party &amp;
              Parties</strong>&quot; shall respectively be used to refer to the User
            and the Company individually and collectively, as the context so
            requires.
          </li>
          <li>&quot;<strong>Paid Subscription</strong>&quot; shall mean
            and refer to the subscription after the free trial period for which
            the required payment has been made.
          </li>
        </ol>

        <p>The headings of each section in this Agreement are only for the
          purpose of organising the various provisions under this Agreement in
          an orderly manner. These headings shall not be used by either party to
          interpret the provisions contained under them in any manner. Further,
          the headings have no legal or contractual value.</p>

        <h4><strong>2. <u>WEBSITE/APP</u></strong></h4>

        <p>Paperflite is Software as a Service (SaaS) content management
          and sales enablement Website/App. It adds intelligence to sales
          content so account executives and sales representatives can drive
          relevant and personalized conversations with customers.</p>

        <p>
          <strong><u>Subscriptions:</u></strong>
        </p>

        <p>The sales enablement Website/App has three integrated modules
          specifically designed to align marketing, sales and prospects in the
          buyer journey.</p>

        <ul>
          <li>Online Publisher</li>
          <li>Paperflite App</li>
          <li>FliteView</li>
        </ul>

        <p>Paperflite offers different subscription models that vary in
          features by the package offered. The latest information on the types
          of packages that Paperflite offers and the costs involved can be found
          on the Website: <a href="http://www.paperflite.com">www.paperflite.com</a>. Paperflite reserves the right, at
          any time, to change the subscription types and their restrictions
          and/or impose fees for access to and use of the website/app and
          services.</p>

        <p>
          <strong><u>Trials:</u></strong>&nbsp;
        </p>

        <p>
          We may offer fourteen (14) days of trial for all the above mentioned 
          plans without payment  (a &quot;<strong>Trial</strong>&quot;).
          Paperflite however, reserves the right, in its absolute discretion, to 
          determine your eligibility for a Trial, and to withdraw or to modify a 
          Trial at any time without prior notice and with no liability.
        </p>

        <p>&nbsp;</p>

        <h4><strong>3. <u>ELIGIBILITY</u></strong></h4>

        <p>The use and access of the Website/App /App and Services are
          available only to those above the age of 18 years from accessing or
          using the Website/App by any other applicable law, rule or regulation
          currently in force.&nbsp;</p>

        <p>If you are a minor and wish to use the Website/App, you may do
          so through your legal guardian. We reserve the right to terminate your
          account on knowledge of you being a minor and having registered on the
          Website/App or availing any of its Services.</p>

        <p>&nbsp;</p>

        <h4><strong>4. <u>REGISTRATION</u></strong></h4>

        <p>Before you may access and use the Services, you will need to
          register with Paperflite and create an account. Accurate, up to date
          and complete information about you is required to be maintained.
          Neither accessing accounts of other members nor authorizing any third
          party to access your account is prohibited. Each Paperflite account
          may only be used by a single person. You agree to contact Paperflite
          immediately in the event of any suspected or actual misuse or breach
          of security or unauthorized use of your account. You are solely
          responsible for your account activity and you must keep your account
          and passwords confidential and secure. Paperflite is not responsible
          or liable for any loss or damage arising from any unauthorized use of
          your account.</p>

        <p>By creating an account with Paperflite and providing Paperflite
          your email address, you agree that Paperflite may use your email
          address to send you notices and information regarding the Services,
          including notices regarding violations of these Terms of Use, updates,
          changes to features of the Services and special offers, or notices
          required by law. You may opt out of receiving certain Services-related
          notices by changing your account settings.</p>

        <p>We may disclose User Provided and Automatically Collected
          Information:</p>

        <h4>&nbsp;</h4>

        <h4>
          <strong>5. <u>USER&rsquo;s OBLIGATION</u></strong>
        </h4>

        <p>The Authorized Users of undertakes to fulfil the following obligations :</p>
        <ul>
          <li>You agree to provide genuine credentials during the process ofregistration.</li>
          <li>You agree to ensure the email address provided during the registration process is valid at all times and shall keep its contact information accurate and up-to-date.</li>
          <li>You agree to comply with all applicable local laws and regulations governing the use of the Website/App, including, without limitation to, any usage rules set forth in this Agreement.</li>
          <li>You agree that you are solely responsible for maintaining the confidentiality of your account password. You agree to notify Paperflite immediately of any unauthorized use of your account.</li>
          <li>You agree to comply with all local laws and regulations governing the downloading, installation and/or use of the Website/App, including, without limitation to, any usage rules set forth in this Agreement.</li>
          <li>You understand that accessing the Website/App and transacting at its sole risk and that it is using best and prudent judgment before availing any Services listed on the Website/App,or accessing/using any information displayed thereon.</li>
          <li>You agree not to use the Services to harm, threaten, or harass another person, organization, or Paperflite. In addition, You agree not to: 
            <ul>
              <li>damage, disable, overburden, or impair the Services (or any network connected to the Services); resell or redistribute the Services or any part of it; use any unauthorized means to modify, reroute, or gain access to the Services or attempt to carry out these activities; or use any automated process or service (such as a bot, a spider, or periodic caching of information stored by Paperflite) to access or use the Services.</li>
              <li>license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, time share or otherwise commercially exploit or make the Service(s) available to any third party, other than Users and End-Customers in furtherance of your internal business purposes as expressly permitted by these Terms;</li>
            </ul>
          </li>
          <li>You also agree that you will not and will not encourage or assist any third party to modify, alter, tamper with, repair or otherwise create derivative works of any Software;
            <ul>
              <li>reverse engineer, disassemble or decompile the software used to provide or access the Services, including the Software, or attempt to discover or recreate the source code used to provide or access the Services, except and only to the extent that the applicable law expressly permits doing so;</li>
              <li>use the Services in any manner or for any purpose other than as expressly permitted by these Terms of Use, the Privacy Policy, the Terms of Sale any Documentation or any other policy, instruction or terms applicable to the Services that are available on the Services </li>
              <li>remove, obscure or alter any proprietary rights notice pertaining to the Services;</li>
              <li>access or use the Services in a way intended to improperly avoid incurring fees or exceeding usage limits or quotas;</li>
              <li>use the Services to: (i) engage in any unlawful or fraudulent activity or perpetrate a hoax or engage in phishing schemes or forgery or other similar falsification or manipulation of data; (ii) send unsolicited or unauthorized junk mail, spam, chain letters, pyramid schemes or any other form of duplicative or unsolicited messages, whether commercial or otherwise; (iii) advertise or promote a commercial product or service that is not available through Paperflite unless your account is subject to a business or enterprise subscription service; (iv) store or transmit inappropriate Content, such as Content: (1) containing unlawful, defamatory, threatening, pornographic, abusive, libellous or otherwise objectionable material of any kind or nature, (2) containing any material that encourages conduct that could constitute a criminal offense, or (3) that violates the intellectual property rights or rights to the publicity or privacy of others; (iv) store or transmit any Content that contains or is used to initiate a denial of service attack, software viruses or other harmful or deleterious computer code, files or programs such as Trojan horses, worms, time bombs, cancel bots, or spyware; or (v) abuse, harass, stalk or otherwise violate the legal rights of a third party;</li>
              <li>interfere with or disrupt servers or networks used by Paperflite to provide the Services or used by other users’ to access the Services, or violate any third party regulations, policies or procedures of such servers or networks;</li>
              <li>access or attempt to access Paperflite’s other accounts, computer systems or networks not covered by these Terms of Use, through password mining or any other means;</li>
              <li>cause, in Paperflite’s sole discretion, inordinate burden on the Services or Paperflite’s system resources or capacity; or</li>
              <li>share passwords or other access information or devices or otherwise authorize any third party to access or use the Software or the Services.</li>
              <li>engage in any activity that interferes with or disrupts access to the Website/App or the Services (or the servers and networks which are connected to the Website/App);</li>
              <li>upload or distribute files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of the Website/App or another's mobile phone, systems, devises and software solutions that are extentions of the Website/App;</li>
              <li>download any file posted in the Website/App that you know, or reasonably should know, cannot be legally distributed in such manner;</li>
              <li>probe, scan or test the vulnerability of the Website/App or any network, devices and software solutions to the Website/App, nor breach the security or authentication measures on the Website/App or any network, devises and software solutions connected to the Website/App . You may not reverse look-up, trace or seek to trace any information on any other user, of or visitor to, the Website/App , or exploit the Website/App  or Service or information made available or offered by or through the Website/App , in any way whether or not the purpose is to reveal any information, including but not limited to personal identification information, other than Your own information, as provided for by the Website/App ;</li>
              <li>disrupt or interfere with the security of, or otherwise cause harm to, the Website/App , systems resources, servers, software solutions or networks connected to or accessible through the Website/App  or any affiliated or linked Website/App;</li>
              <li>use the Website/App  or any material or content for any purpose that is unlawful or prohibited by these Terms of Use, or to solicit the performance of any illegal activity or other activity which infringes the rights of this Website/App  or other Third Parties;</li>
              <li>violate any applicable laws or regulations for the time being in force within or outside You’s home country;</li>
              <li>violate any code of conduct or other guidelines, which may be applicable for or to any particular Service; </li>
              <li>threaten the unity, integrity, defence, security or sovereignty of your home country, friendly relations with foreign states, or public order or causes incitement to the commission of any cognizable offence or prevents investigation of any offence or is insulting any other nation;</li>
              <li>disseminate information through the Website/App  that is false, inaccurate or misleading, or violate any applicable laws or regulations for the time being in force in or outside your home country.</li>
            </ul>
          </li>
        </ul>

        <p>&nbsp;</p>

        <h4>
          <strong>6. <u>Content</u></strong>
        </h4>

        <p>
          You are solely responsible for any and all data, documents, files,
          text, audio, video, images or other content or materials that you
          deliver, upload to or make accessible in the Solution &quot;<strong>Content</strong>&quot;)
          and Paperflite will not review, share or distribute any Content except
          to the extent necessary to provide and upgrade the Services or as may
          be required by law.
        </p>
        <p>Except for material that we license to you, we don&rsquo;t claim
          ownership of any Content that is transmitted, stored, or processed in
          your account(s). We also don&rsquo;t control, verify, or endorse the
          Content that you or others make available on the Services.</p>
        <p>You hereby grant Paperflite a non-exclusive license to use,
          modify, adapt, reproduce, distribute and display your Content, but
          solely to the extent necessary to provide the Services or as otherwise
          permitted by these Terms of Use.</p>
        <p>You represent and warrant that: (a) you have all the rights in
          the Content necessary for you to use the Services and to grant the
          rights in this Section, and, (b) the storage, use or transmission of
          the Content will not violate these Terms of Use or applicable laws.</p>
        <p>You agree that you will: (a) promptly address and respond any
          notices or claims relating to the Content; and (b) maintain
          appropriate security, protection and backup copies of the Content,
          which may include, your use of additional encryption technology to
          protect the Content from unauthorized access. Paperflite will have no
          liability of any kind as a result of the deletion of, correction of,
          destruction of, damage to, loss of or failure to store or encrypt any
          Content.</p>
        <p>You will immediately notify Paperflite in writing of any
          unauthorized use of (a) any Content (b) your account, or (c) the
          Services and you agree to take reasonable steps to terminate such
          unauthorized use. Upon Paperflite&rsquo;s reasonable request, you will
          cooperate with and provide assistance to Paperflite in connection with
          any such unauthorized use.</p>
        <p>Paperflite reserves the right to block or otherwise prevent
          delivery of any Content if, in Paperflite&rsquo;s sole discretion,
          such Content violates these Terms of Use.</p>
        <p>The Solution includes certain functionality that allows you to
          control access to your Content. Please review your account settings
          prior to using and accessing the Solution and make any modifications
          that you deem necessary or appropriate to control access to your
          Content by third parties.</p>
        <p>We retain the right to block or otherwise prevent delivery of
          any Content to or from the Service as part of our efforts to protect
          the Services, protect our customers, or stop you from breaching these
          Terms of Use. The technology or other means we use may hinder or
          disable your use of the Services.</p>

        <p>&nbsp;</p>

        <h4>
          <strong>7. <u>INTELLECTUAL PROPERTY RIGHTS</u></strong>
        </h4>

        <ol type="i">
          <li>All rights related to the Paperflite Website/App design, text, graphics and other content, 
            the selection and arrangements are licensed to the Company. 
            The content of this Website/App is protected by international copyright laws and other intellectual property rights. 
            All names and logos mentioned in this Website/App are the trademarks, 
            service-marks or trading names of their respective owners, 
            including us. You may not modify, copy, reproduce, republish, upload, post, 
            transmit or distribute by any means or in any manner, any material or 
            information on the Website/App or downloaded from this Website/App 
            including but not limited to text, graphics, video, messages, 
            code and/or software without Our prior written consent, except where expressly invited to do so. 
            All user generated content including documents, text, graphics created/uploaded/shared/owned belongs to the 
            User/Customer and Paperflite shall not acquire any right, title or interest in or to such Intellectual Property Rights.
          </li>
          <li>You may not, republish any portion of the content on any
            Internet, Intranet or extranet site or incorporate the content in any
            database, compilation, archive or cache. You may not distribute any
            content to others, whether or not for payment or other consideration,
            and you may not modify copy, frame, cache, reproduce, sell, publish,
            transmit, display or otherwise use any portion of the content. You
            may not scrape or otherwise copy our content without permission. You
            agree not to decompile, reverse engineer or disassemble any software
            or other Services or processes accessible through the Website/App,
            not to insert any code or manipulate the content of the Website/App
            in any way that affects the user's experience, and not to use any
            data mining, data gathering or extraction method.</li>
          <li>You may not use any of our intellectual property in any
            manner that is likely to cause confusion among Users, or in any
            manner that disparages or discredits us in any way.</li>
          <li>If you believe your work has been copied in a way that
            constitutes infringement or are aware of any infringing material on
            the Website/App , please email us at support@paperflite.com.</li>
          <li>When Customers provide feedback, suggestions, feature
            requests such material shall belong to Paperflite and that the
            Customer relinquishes any claims in future when such materials are
            protected by Paperflite in their name.</li>
        </ol>

        <h4>&nbsp;</h4>

        <h4>
          <strong>8. <u>PRIVACY POLICY</u></strong>
        </h4>

        <p>In case you use the Site, App, Content or Services, Paperflite
          may process your personal data. For further information on how we
          process your personal data, please see our Privacy Policy.&nbsp;</p>

        <h4>
          <strong>9. <u>TERM AND TERMINATION</u></strong>
        </h4>

        <p>These Terms shall continue to form a valid and binding contract
          between the Parties, and shall continue to be in full force and effect
          until the User continues to access and use the Website/App. We reserve
          the right, in our sole discretion, to unilaterally terminate the
          User&rsquo;s access to the Services offered on the Website/App, or any
          portion thereof, at any time, without notice or cause. The User shall
          continue to be bound by these Terms, and it is expressly agreed to by
          the Parties that the User shall not have the right to terminate these
          Terms till the expiry of the same. &nbsp;</p>

        <h4>
          <strong>10. <u>COMMUNICATIONS</u></strong>
        </h4>

        <p>By using this Website/App, it is deemed that you have consented
          to receiving telephonic calls, SMS and/or emails from us at any time
          we deem fit. Such communications shall be sent to you on the telephone
          number and/or email id provided by you for the use of this Website/App
          which is subjected to our Privacy Policy. These communications
          include, but are not limited to contacting you through information
          received from third parties. Such communications by us is for purposes
          that inter alia include clarification calls, marketing calls and
          promotional calls. In case you wish to stop receiving notifications
          from us with regard to marketing and promotional calls/ with regard to
          any communication received from us, you may email us at
          support@paperflite.com.&nbsp;</p>

        <p>You may also be contacted by service providers with whom we have
          entered into a contract in furtherance of our rights, duties and
          obligations under this document and other policies followed by us and
          with whom you have become friends with from the Website/App. Such
          contact shall be made only in pursuance of such objectives, and no
          other calls shall be made.</p>

        <p>In addition, you may also be contacted by Third Parties who may
          have access to the information disclosed by you or to whom we may have
          disclosed your information for purposes such as, but not limited to,
          statistical compilations.</p>

        <p>&nbsp;</p>

        <h4>
          <strong>11. <u>CHARGES AND CANCELLATION</u></strong>
        </h4>

        <p>Charges shall be recurring on a monthly basis based on the
          package chosen. All the fees paid to Paperflite are non-refundable for
          the services rendered, whether or not Service Contracts were
          satisfactorily completed.</p>

        <p>If you have a Paid Subscription, your payment to Paperflite will
          automatically renew at the end of the subscription period, unless you
          cancel your Paid Subscription through your subscription page before
          the end of the current subscription period. The cancellation will take
          effect the day after the last day of the current subscription period,
          and you will be downgraded to the Free Service.</p>

        <p>We reserve the right to amend the fee policy and charge for all
          the Services which the Website/App /App offers. In the event of such
          change in policy, Users shall be intimated of the same via
          email/telephone and such change shall be effective as soon as Users
          have been intimated. Subsequent to such change, it is the choice of
          the User whether or not to continue with the services offered by us.</p>

        <p>&nbsp;</p>

        <h4>
          <strong>12. <u>MODE OF PAYMENT</u></strong>
        </h4>

        <p>To process any financial transactions on the
          Platform/Website/App, we use third-party electronic payment processors
          or service providers (ESPs). As required, you can permanently
          authorize us to instruct such ESPs to handle Account deposits and
          withdrawals from your account. You also permanently agree that in
          accordance with your requests as submitted, we may give such
          instructions on your behalf. You agree to be certain by the terms and
          conditions of use of each appropriate ESP. In the event of conflict
          between these Agreements and the ESP's terms and conditions, these
          Agreements shall prevail.</p>

        <p>As prescribed by the financial institutions issuing the credit
          or debit cards affiliated with Visa / Master Card / Amex, the User
          will be required to submit his/her 16-digit card number, card expiry
          date and 3-digit CVV number (usually on the reverse of the card) while
          making an online transaction. The User must also have enrolled his/her
          card with VBV (Verified by Visa) or MSC (MasterCard Secure Code) in
          order to complete the transaction.</p>

        <h4>
          <strong>13. <u>TAXES</u></strong>
        </h4>

        <p>The User takes full responsibility for payment of all taxes and
          fees that are levied or arise in the course of use of the Website/App.
          There are sometimes laws and taxes that affect Internet e-commerce.
          The User agrees that it is their responsibility to comply with such
          laws and will hold harmless, protect, and defend the Company and its
          subcontractors from any claim, suit, penalty, tax, or tariff arising
          from the User&rsquo;s exercise of Internet e-commerce.</p>

        <h4>
          <strong>14. SECURITY</strong>
        </h4>

        <p>Transactions on Paperflite&rsquo;s Website/App are secure and
          protected. Any information entered by the User when transacting on
          Paperflite&rsquo;s Website/App is encrypted to protect the User
          against unintentional disclosure to third parties. The User&rsquo;s
          credit and debit card information is not received, stored by or
          retained by the Website/App in any manner. This information is
          supplied by the User directly to the relevant payment gateway which is
          authorized to handle the information provided, and is compliant with
          the regulations and requirements of various banks and institutions and
          payment franchisees that it is associated with.</p>

        <h4>
          <strong>15. <u>NOTICES</u></strong>
        </h4>

        <p>Any and all communication relating to any dispute or grievance
          experienced by the User may be communicated to the Company by the User
          reducing the same to writing, and sending the same to the registered
          office of the Company by Registered Post, or send an email to
          support@paperflite.com.</p>

        <h4>
          <strong>16. <u>TERMINATION</u></strong>
        </h4>

        <p>Paperflite reserves the right, in its sole discretion, to
          unilaterally terminate the User&rsquo;s access to the services offered
          on the Paperflite Website/App, or any portion thereof, at any time,
          without notice or cause. The User shall continue to be bound by these
          Terms, and it is expressly agreed to by the Parties that the User
          shall not have the right to terminate these Terms till the expiry of
          the same.</p>

        <p>Content will be deleted upon 30 days after agreement
          termination. Content/Data shall be retained by Paperflite and can be
          downloaded and given to Users upon request within 30 days from
          Agreement end date.</p>

        <h4>
          <strong>17. <u>GEOGRAPHICAL EXTENT</u></strong>
        </h4>

        <ol type="a">
          <li>The Website/App can be used in all countries worldwide. We
            make no representation that materials or content available through
            our Website/App is appropriate or available for use in all countries.</li>
          <li>(b) If you access or use the Website/App from a country or
            location apart from those specified above, you are solely responsible
            for compliance with necessary laws and regulations for use of the
            Website/App.</li>
        </ol>
        <h4>
          <strong>18. <u>AMENDMENT</u></strong>
        </h4>

        <p>We may modify, replace, refuse access to, suspend or discontinue
          the Services, partially or entirely, or add, change and modify prices
          for all or part of the Services for you or for all Users at any time
          and in our sole discretion. These changes shall become effective upon
          providing a notice of the same to you via email/ the home screen of
          the Website/App . We further reserve the right to withhold, remove and
          or discard any content available as part of your account, with or
          without notice, if deemed by us to be contrary to this Agreement.</p>

        <h4>
          <strong>19. <u>INDEMNITY</u></strong>
        </h4>

        <p>You agree to defend, indemnify, and hold Paperflite, its
          officers, directors, employees and agents, harmless from and against
          any claims, liabilities, damages, losses and expenses, including,
          without limitation, reasonable attorneys&rsquo; fees and costs, arising
          out of or in any way connected with:</p>

        <ul>
          <li>your access to or use of the Services;</li>
          <li>your violation of any provision of the Agreement;</li>
          <li>your violation of any third party right, including without
            limitation any intellectual property right, including but not limited
            to right of attribution, publicity, confidentiality, property or
            privacy right (including right of portrayal.</li>
        </ul>

        <h4>
          <strong>20. <u>LIMITATION OF LIABILITY</u></strong>
        </h4>

        <p>IN NO EVENT WILL PAPERFLITE BE LIABLE TO YOU OR TO ANY THIRD
          PARTY FOR DAMAGES OF ANY KIND, INCLUDING, WITHOUT LIMITATION, DIRECT,
          SPECIAL, INCIDENTAL, PUNITIVE OR CONSEQUENTIAL DAMAGES (INCLUDING LOSS
          OF USE, DATA, BUSINESS OR PROFITS) ARISING OUT OF OR IN CONNECTION
          WITH THIS AGREEMENT, OR FROM YOUR ACCESS TO OR USE OF, OR INABILITY TO
          ACCESS OR USE, THE WEBSITE, APP, CONTENT, AND/OR SERVICES, OR FOR ANY
          ERROR OR DEFECT IN THE WEBSITE, APP, CONTENT, OR SERVICES, WHETHER
          SUCH LIABILITY ARISES FROM ANY CLAIM BASED UPON CONTRACT, WARRANTY,
          TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHERWISE, OR ANY
          OTHER LEGAL THEORY, WHETHER OR NOT PAPERFLITE HAS BEEN INFORMED OF THE
          POSSIBILITY OF SUCH DAMAGE, EVEN IF A REMEDY SET FORTH HEREIN IS FOUND
          TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. YOU SPECIFICALLY ACKNOWLEDGE
          THAT PAPERFLITE IS NOT LIABLE FOR THE DEFAMATORY, OFFENSIVE OR ILLEGAL
          CONDUCT OF OTHER USERS OR THIRD PARTIES AND THAT THE RISK OF INJURY
          FROM THE FOREGOING RESTS ENTIRELY WITH YOU. FURTHER, PAPERFLITE WILL
          HAVE NO LIABILITY TO YOU OR TO ANY THIRD PARTY FOR ANY THIRD PARTY
          CONTENT UPLOADED ONTO OR DOWNLOADED FROM THE WEBSITE, APP AND/OR
          THROUGH THE SERVICES, OR IF YOUR DATA IS LOST, CORRUPTED OR EXPOSED TO
          UNINTENDED THIRD PARTIES.</p>

        <h4>
          <strong>21. <u>DISPUTE RESOLUTION, GOVERNING LAW AND
            JURISDICTION</u></strong>
        </h4>

        <p>All disputes involving but not limited to rights conferred,
          compensation, refunds, and other claims will be resolved through a
          two-step Alternate Dispute Resolution mechanism.</p>

        <ol type="a">
          <li><strong>Stage 1: Mediation.</strong> In case of a dispute,
            the matter will first be attempted to be resolved by a sole mediator
            who is a neutral third party and will be selected at the mutual
            acceptance of a proposed mediator by both parties. Both parties may
            raise a name for the sole mediator and in the case both parties
            accept the proposed name, the said person shall be appointed as sole
            mediator. In case the parties are not able to reach a consensus
            within two proposed mediators, the sole proprietorship reserves the
            right to decide who the final mediator is. The decision of the
            mediator is not binding on both parties.</li>
          <li><strong>Stage 2: Arbitration.</strong> In case that mediation
            does not yield a result suitable or preferred by any one of the
            parties, arbitration may follow, the award of which is binding on
            both parties. The Arbitration Board shall comprise three members
            &minus; one appointed by each party and the third member to be
            nominated by the two appointed members by mutual consent. Arbitration
            shall be held at Delaware, United States. The proceedings of
            arbitration shall be in the English language. The arbitrator&rsquo;s
            award shall be final and binding on the Parties.</li>
          <li>The formation, interpretation and performance of this
            Agreement and any disputes arising out of it shall be governed by the
            law, rules and regulations of State of Delaware, United States. The
            exclusive jurisdiction and venue for actions and disputes mentioned
            above shall be the Federal courts located in the State of Delaware,
            United States and you hereby submit to the jurisdiction of such
            courts.</li>
        </ol>

        <h4>
          <strong>22. <u>MISCELLANEOUS PROVISIONS:</u></strong>
        </h4>

        <ol type="a">
          <li><strong>Entire Agreement:</strong> This Agreement is the
            complete and exclusive statement of the agreements between you and us
            with respect to the subject matter hereof and supersedes all other
            communications or representations or agreements (whether oral,
            written or otherwise) relating thereto.</li>
          <li><strong>Waiver:</strong> The failure of either party at any
            time to require performance of any provision of this Agreement in no
            manner shall affect such party's right at a later time to enforce the
            same. No waiver by either party of any breach of this Agreement,
            whether by conduct or otherwise, in any one or more instances, shall
            be deemed to be, or construed as, a further or continuing waiver of
            any other such breach, or a waiver of any other breach of this
            Agreement.</li>
          <li><strong>Severability:</strong> If any provision of this Agreement shall to
            any extent be held invalid, illegal or unenforceable, the validity,
            legality and enforceability of the remaining provisions of this
            Agreement shall in no way be affected or impaired thereby and each
            such provision of this Agreement shall be valid and enforceable to
            the fullest extent permitted by law. In such a case, this Agreement
            shall be reformed to the minimum extent necessary to correct any
            invalidity, illegality or unenforceability, while preserving to the
            maximum extent the rights and commercial expectations of the parties
            hereto, as expressed herein.</li>
        </ol>
        
        <p>If you have any questions please send us an email to support@paperflite.com. </p>

      </div>
      );
    }
}

export default TermsView;